import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { Logger, SiteConfigManager, useSettings } from '@atlas/core';

import { CDN_TYPE_CMS, getCDNUrl } from 'common/utils';

const LogoImage = ({ logoSrc, metaTitle }) => {
  if (!logoSrc) return null;

  return <img alt={metaTitle} className="logo__img" src={logoSrc} />;
};

LogoImage.propTypes = {
  logoSrc: PropTypes.string,
  metaTitle: PropTypes.string,
};

const HeaderLogoItem = ({ isNativeLink, redirectTo }) => {
  const { theme } = useSettings();
  const metaTitle = SiteConfigManager.getConfig('config.config.seo.default_meta_title', '');

  const logoImgSrc = React.useMemo(() => {
    const cdnPathName = getCDNUrl(CDN_TYPE_CMS);
    try {
      const logoName = `logo_desktop_${theme || SYS_CONFIG.defaultTheme || 'dark'}`;
      const logo = SiteConfigManager.getConfig(logoName);

      if (!logo) {
        return null;
      }

      return `${cdnPathName}/${logo}`;
    } catch (error) {
      Logger.error('unable to load logo', error);

      return '';
    }
  }, [theme]);

  if (!redirectTo) {
    return (
      <div className="logo">
        <LogoImage logoSrc={logoImgSrc} metaTitle={metaTitle} />
      </div>
    );
  }

  if (isNativeLink) {
    return (
      <a aria-label={metaTitle} className="logo" href={redirectTo}>
        <LogoImage logoSrc={logoImgSrc} metaTitle={metaTitle} />
      </a>
    );
  }

  return (
    <Link aria-label={metaTitle} className="logo" to="/">
      <LogoImage logoSrc={logoImgSrc} metaTitle={metaTitle} />
    </Link>
  );
};

HeaderLogoItem.propTypes = {
  isNativeLink: PropTypes.bool,
  redirectTo: PropTypes.string,
};

export default React.memo(HeaderLogoItem);
